var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v("Линии")]),_c('v-expansion-panel-content',[_vm._v(" Under construction... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }